// Preferências de som, guardadas no aparelho. Sem acesso ao armazenamento, vale o padrão (ligado).
import { useSyncExternalStore } from 'react';

export interface PreferenciasSom { som: boolean; vozesGravadas: boolean }

const CHAVE = 'truco6:som';
const ouvintes = new Set<() => void>();
let atual: PreferenciasSom = ler();

function ler(): PreferenciasSom {
  try {
    const p = JSON.parse(localStorage.getItem(CHAVE) ?? '{}') as Partial<PreferenciasSom>;
    return { som: p.som !== false, vozesGravadas: p.vozesGravadas !== false };
  } catch { return { som: true, vozesGravadas: true }; }
}

export function preferencias(): PreferenciasSom { return atual; }

export function mudarPreferencias(parte: Partial<PreferenciasSom>): void {
  atual = { ...atual, ...parte };
  try { localStorage.setItem(CHAVE, JSON.stringify(atual)); } catch { /* sem armazenamento: vale só nesta aba */ }
  for (const f of ouvintes) f();
}

export function usePreferenciasSom(): PreferenciasSom {
  return useSyncExternalStore((f) => { ouvintes.add(f); return () => ouvintes.delete(f); }, preferencias);
}
